export default "__VITE_ASSET__uyThxzAJ__";